import React from 'react';

import PopupMenu from '../../popupmenu/PopupMenu';
import ModalDialog from '../../modal/ModalDialog';

import { performApiRequest, 
	PROFILE_GET_API_URL, PROFILE_SAVE_API_URL, PROFILE_SAVE_BUNDLE_API_URL 
} from '../../../util/restapi';
import { getCurrentResource } from '../../../util/tools';

import iconProfile from '../../../assets/icons/png24x24/Box.png';

class ButtonProfile extends React.Component {

	rateView = null;
	listProfile = [];
	
	/*
		holder, 
		formUrl, 
		mode, 
		style, 
		text, 
		tooltip, 
		icon
	*/
	constructor(props) {
		super(props);
		this.rateView = props.holder;
		this.resource = getCurrentResource().components.rateview.button.ButtonProfile;
		this.refSaveNewProfileModalDialog = React.createRef();
		this.refProfileListModalDialog = React.createRef();
		this.refModalProfileList = React.createRef();
		
		this.state = { 
			listProfile: this.listProfile,
			activeProfile: null,
			dirtyCount: 0 
		};

	}
	componentDidMount = async () => {
		this.updateListProfile();
	}

	updateListProfile = async () => {
		let requestProfile = {
			formId: this.rateView.props.rvContext.form
		}
		let responseProfile = await performApiRequest( PROFILE_GET_API_URL, requestProfile );
		if( responseProfile.success ) {
			this.listProfile = responseProfile.listProfile;
		}
		this.setState({listProfile: this.listProfile})
	}

	saveProfile = async (isNew) => {
		if( isNew ) {
			let profile = {
				id: null,
				alias: this.rateView.userInfo.login,
				formId: this.rateView.rvContext.form,
				name: this.resource.textNewName
			};
			this.rateView.fetchProfile( profile );
			this.refSaveNewProfileModalDialog.current.prepareOpen( profile );
			this.refSaveNewProfileModalDialog.current.openModal();
		} else {
			let profile = this.rateView.activeProfile;
			this.rateView.fetchProfile( profile );
			this.response = await performApiRequest( PROFILE_SAVE_API_URL, { profile: this.profile } );
		}
	}

	editProfiles = () => {
		this.refProfileListModalDialog.current.openModal();
	}
	
	applyProfile = (profile) => {
		this.rateView.applyProfile(profile);
		this.activeProfile = profile;		
		this.setState({activeProfile: this.activeProfile})
	}

	render() {
//		return null;
		if( this.rateView.props.rvOptions.hideButtonProfile )
			return null;
		let button = {
			text: this.resource.buttonProfileText, 
			tooltip: this.resource.buttonProfileTooltip, 
			icon: iconProfile
		};
		let listProfile = this.listProfile;
		let itemSave = {method: () => { this.saveProfile(false)}};
		if( this.activeProfile == null ) {
			itemSave.title = this.resource.menuSave;
			itemSave.disabled = true;
		} else {
			itemSave.title = this.resource.menuSave + " (" + this.activeProfile.name + ')'; 
			itemSave.disabled = false;
		}
		let menu = { items: [
			itemSave,
			{ title: this.resource.menuSaveAs + '...', method: () => { this.saveProfile(true)} },
			{ title: this.resource.menuProfiles + '...', method: () => { this.editProfiles()}, disabled: listProfile.length == 0 },
		] };
		if( listProfile.length > 0 )
			menu.items.push( { isSeparator: true } );
		for(let profile of listProfile) {
			menu.items.push( {
				title: profile.name,
				method: () => { this.applyProfile(profile) }
			} )
		}
		let style = {marginLeft: '10px'};
		return (
			<React.Fragment>
				<PopupMenu holder={this.rateView} style={style} button={button} menu={menu} />
				<SaveNewProfileModalDialog ref={this.refSaveNewProfileModalDialog} holder={this} />
				<ProfileListModalDialog ref={this.refProfileListModalDialog} holder={this} rateView = {this.rateView} />
			</React.Fragment>
		);
	}

}

class SaveNewProfileModalDialog extends ModalDialog {

	profile = null;
	resource = null;

	constructor(props) {
		super(props);
		this.resource = props.holder.resource;
		this.showTryAgainButton = false;
		this.title=this.resource.modalDlgSaveNewTitle;
		this.state.name = '';
	}
	prepareOpen(profile) {
		this.profile = profile;
		this.setState({name: profile.name})
	}
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}
	handleValueChange =(e) => {
		this.setState({name: e.target.value});
	}

	async performRequest() {
		this.profile.name = this.state.name;
		let request = {
			profile: this.profile
		}
		let response = await performApiRequest(PROFILE_SAVE_API_URL, request);
		if( response.success ) {
			let holder = this.props.holder;
			holder.activeProfile = response.data;
			holder.listProfile.push(response.data); 
			holder.setState({dirtyCount: holder.state.dirtyCount+1})			
		}
		return response;
	}

	renderForm() {
		return (
			<div style={{marginTop: '10px', padding: '10px'}}>
				<div>
					{this.resource.labelName}
					<input type='text' style={{marginLeft: '15px', width: '350px'}}
						onChange={this.handleValueChange} value={this.state.name}
					/>
				</div>
			</div>
		)
	}
}

class ProfileListModalDialog extends ModalDialog {

	rateView = null;
	resource = null;
	
	listProfile = [];
	listProfileEdited = [];
	listIdDeleted = [];

	constructor(props) {
		super(props);
		this.rateView = props.rateView;

		this.resource = props.holder.resource;
		this.populateInitialData = true;
		this.title=this.resource.modalDlgProfilesTitle;
		this.buttonOkText = this.resource.buttonOkText;
	}
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}

	async performPopulateInitialData() {
		let requestProfile = {
			formId: this.rateView.props.rvContext.form
		}
		let response = await performApiRequest( PROFILE_GET_API_URL, requestProfile );
		if( response.success ) {
			let selectedIndex = -1;
			let selectedName = '';
			this.listProfile = response.listProfile;
			if( this.listProfile.length > 0 ) {
				selectedIndex = 0;
				selectedName = this.listProfile[0].name; 				
			}
			this.listProfileEdited = [];
			this.listIdDeleted = [];
			this.setState({listProfile: this.listProfile, profileName: selectedName,  selectedIndex: selectedIndex})
		}
		return response;
	}
	async performRequest() {
		let request = {
			listProfileEdited: this.listProfileEdited,
			listIdDeleted: this.listIdDeleted,
		}

		let response = await performApiRequest( PROFILE_SAVE_BUNDLE_API_URL, request );
		if( response.success ) {
			let holder = this.props.holder;
			holder.listProfile = this.listProfile; 
			holder.setState({listProfile: this.listProfile})			
		}
		return response;
	}

	handleNameChange = (e) => {
		let index = this.state.selectedIndex;
		if( index < 0 )
			return;
		let profile = this.listProfile[ index ];
		profile.name = e.target.value
		let indexEdited = this.indexOfEditedProfile( profile.id );
		if( indexEdited < 0 )
			this.listProfileEdited.push( {id: profile.id, name: profile.name} );
		else
			this.listProfileEdited[indexEdited].name = profile.name;
		this.setState({listProfile: this.listProfile, profileName: profile.name})
		
	}
	selectRow = (index) => {
		this.setState({profileName: this.listProfile[index].name, selectedIndex: index})
	}
	deleteProfile = () => {
		let index = this.state.selectedIndex;
		if( index < 0 )
			return;
		let profileId = this.listProfile[index].id;
		this.listIdDeleted.push( profileId );
		this.listProfile.splice(index, 1);
		if( index >= this.listProfile.length )
			index--;
		
		let name = ''
		if( index >= 0 )
			name = this.listProfile[index].name;
		let indexEdited = this.indexOfEditedProfile( profileId );
		if( indexEdited >= 0 )
			this.listProfileEdited.splice(indexEdited);
		this.setState({listProfile: this.listProfile, profileName: name, selectedIndex: index})
	}
	indexOfEditedProfile = (profileId) => {
		for(let i=0; i < this.listProfileEdited.length; i++) {
			if( this.listProfileEdited[i].id == profileId ) {
				return i;
			}
		}
		return -1;
	}

	renderForm() {
		let listRowHtml = this.listProfile.map((profile, index) => {
			let bgColor = 'white';
			if( index == this.state.selectedIndex )
				bgColor = 'lightblue';
			return (
				<tr style={{backgroundColor: bgColor, cursor: 'pointer'}} onClick={()=> {this.selectRow(index)}}><td>{profile.name}</td></tr>
			)
		});
		let nameRO = this.state.selectedIndex < 0;
		let divDisplay = this.listProfile.length == 0 ? 'none' : 'block';
		return (
			<div style={{marginTop: '10px', padding: '10px'}}>
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
					<input type='text' style={{height: '20px', flexGrow: '1'}} value={this.state.profileName} 
						onChange={this.handleNameChange} readOnly={nameRO}
					/>
					<button type='button' style={{marginLeft: '20px', height: '30px', padding: '0 20px 0 20px' }} 
						disabled={nameRO} onClick={this.deleteProfile}
					>
						{this.resource.buttonDelete}
					</button>
				</div>
				<div style={{display: divDisplay, marginTop: '20px', marginBottom: '0px', border: '1px solid black'}}>
					<table style={{width: '100%'}}><tbody>
						{listRowHtml}
					</tbody></table>
				</div>
			</div>
		)
	}
}

export default ButtonProfile;
